// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__bEqi7","titlePosition":"styles_titlePosition__2obTb"};